import React, { useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../i18n";
import "./Auth.css";

function LoginForm() {
  const location = useLocation();

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [error, setError] = useState("");
  const [successMessage] = useState(location.state?.message || "");
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useI18n();

  function handleChange(event) {
    const { name, value } = event.target;

    setFormData({
      ...formData,
      [name]: value
    });
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");

    try {
      setSubmitting(true);

      const response = await axios.post(
        "/api/auth/login",
        {
          email: formData.email,
          password: formData.password
        }
      );

      console.log("Login response:", response.data);

      login(response.data);

      console.log("After login user:", localStorage.getItem("user"));
      console.log("After login token:", localStorage.getItem("token"));

      navigate("/");
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      });
    } catch (err) {
      console.error("Login error:", err);

      if (err.response && err.response.data) {
        setError(err.response.data);
      } else {
        setError(t("auth.loginFailed"));
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-shell">
        <div className="auth-info-panel">
          <div className="auth-brand">
            <span className="auth-brand-icon">♥</span>
            <span>TajneMysli</span>
          </div>

          <h1>{t("auth.welcomeBack")}</h1>

          <p>
            {t("auth.loginDescription")}
          </p>

          <div className="auth-feature-list">
            <div className="auth-feature">
              <span>1</span>
              <p>{t("auth.continueDiscovering")}</p>
            </div>

            <div className="auth-feature">
              <span>2</span>
              <p>{t("auth.latestMatches")}</p>
            </div>

            <div className="auth-feature">
              <span>3</span>
              <p>{t("auth.tokenMessages")}</p>
            </div>
          </div>
        </div>

        <div className="auth-card">
          <div className="auth-card-header">
            <h2>{t("auth.login")}</h2>
            <p>{t("auth.loginDescriptionShort")}</p>
          </div>

          {successMessage && (
            <div className="auth-message auth-success">
              {successMessage}
            </div>
          )}

          {error && (
            <div className="auth-message auth-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label htmlFor="email">{t("auth.email")}</label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t("auth.enterEmail")}
                required
              />
            </div>

            <div className="auth-field">
              <label htmlFor="password">{t("auth.password")}</label>
              <div className="auth-password-input-wrap">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder={t("auth.enterPassword")}
                  required
                />
                <button
                  type="button"
                  className="auth-password-toggle"
                  onClick={() => setShowPassword((visible) => !visible)}
                  aria-label={showPassword ? t("auth.hidePassword") : t("auth.showPassword")}
                  title={showPassword ? t("auth.hidePassword") : t("auth.showPassword")}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    {showPassword ? (
                      <>
                        <path d="M3 3l18 18" />
                        <path d="M10.6 10.6a2 2 0 0 0 2.8 2.8" />
                        <path d="M9.9 5.2A10.8 10.8 0 0 1 12 5c5.2 0 8.6 4.3 9.7 7a16 16 0 0 1-3.1 4.1" />
                        <path d="M6.2 6.2C3.9 7.8 2.6 10 2.3 12c.5 1.2 1.6 2.9 3.4 4.3A10.6 10.6 0 0 0 12 19c1 0 2-.2 2.9-.5" />
                      </>
                    ) : (
                      <>
                        <path d="M2.3 12C3.4 9.2 6.8 5 12 5s8.6 4.2 9.7 7c-1.1 2.8-4.5 7-9.7 7s-8.6-4.2-9.7-7Z" />
                        <circle cx="12" cy="12" r="2.5" />
                      </>
                    )}
                  </svg>
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="auth-submit-button"
              disabled={submitting}
            >
              {submitting ? t("auth.loggingIn") : t("auth.login")}
            </button>
          </form>

          <p className="auth-switch-text">
            <Link to="/forgot-password">{t("auth.forgotPassword")}</Link>
          </p>

          <p className="auth-switch-text">
            {t("auth.noAccount")}{" "}
            <Link to="/register">
              {t("auth.createAccount")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginForm;
